<template>
  <div>
    <!-- 更新CPU -->
    <update-modal
      v-if="selected"
      ref="updateModal"
      :class-data-item="selected"
      @refetch-data="refetchTable"
    />

    <b-card no-body>
      <div class="mx-2 mt-2 mb-50">
        <b-row>
          <b-col
            cols="12"
            md="8"
            sm="7"
          >
            <h4 class="mb-0">
              作業分類
            </h4>
            <small>用於讓執行者更加明確待辦所需要執行的動作</small>
          </b-col>

          <b-col
            cols="12"
            md="4"
            sm="5"
            class="mt-50"
          >
            <div class="text-nowrap d-flex justify-content-end">
              <div
                v-b-tooltip.hover.v-secondary
                title="新增"
                class="d-flex align-items-center actions-link-btn"
                @click="onSubmitUpdate(null)"
              >
                <b-img
                  src="/admin/images/table/plus.svg"
                  class="actions-link-btn-image"
                  rounded
                />
              </div>

              <div
                v-b-tooltip.hover.focus.v-secondary
                title="重新整理"
                class="d-flex align-items-center actions-link-btn ml-25"
                @click="refetchTable"
              >
                <b-img
                  src="/admin/images/table/refresh.svg"
                  class="actions-link-btn-image"
                  rounded
                />
              </div>

              <div
                v-b-tooltip.hover.focus.v-secondary
                title="列表顯示"
                class="d-flex align-items-center actions-link-btn ml-25"
              >
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  right
                >
                  <template #button-content>
                    <b-img
                      src="/admin/images/table/setting.svg"
                      class="actions-link-btn-image"
                      rounded
                    />
                  </template>

                  <b-dropdown-form>
                    <b-form-group>
                      <label class="mb-50">
                        列表顯示
                      </label>

                      <b-form-checkbox
                        v-for="column in tableColumnsSearchable"
                        :key="column.key"
                        v-model="column.select"
                        name="table-column"
                        class="mb-1"
                      >
                        {{ column.label }}
                      </b-form-checkbox>
                    </b-form-group>
                  </b-dropdown-form>

                </b-dropdown>
              </div>
            </div>
          </b-col>

        </b-row>
      </div>

      <!-- 顯示個數/搜尋框 -->
      <div class="mx-2 mb-2">
        <b-row>
          <!-- 顯示個數 -->
          <b-col
            cols="12"
            md="6"
            sm="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-sm-0"
          >
            <!-- <label class="text-nowrap">顯示</label> -->
            <v-select
              v-model="perPage"
              :options="perPageOptions"
              :clearable="false"
              class="table-perPage-select"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  沒有<em>{{ search }}</em> 的相關結果
                </template>

                <div v-else>
                  <small>暫無資料</small>
                </div>
              </template>
            </v-select>
          </b-col>

          <!-- 搜尋框 -->
          <b-col
            cols="12"
            md="6"
            sm="8"
          >
            <!-- 搜尋框 -->
            <div class="w-100 mr-1">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="searchQuery"
                  debounce="500"
                  class="d-inline-block"
                  placeholder="搜尋..."
                />
                <b-input-group-append
                  v-if="searchQuery"
                  is-text
                >
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer text-muted"
                    @click="searchQuery = null"
                  />
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>

        </b-row>
      </div>

      <!-- 列表 -->
      <b-table
        ref="refDataListTable"
        :items="getTodoClassListData"
        :fields="tableColumnsFilter"
        responsive
        striped
        hover
        primary-key="id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        show-empty
        :stacked="$store.getters['app/currentBreakPoint'] === 'xs'"
      >
        <!-- 忙碌中 -->
        <template #table-busy>
          <b-skeleton-table
            :rows="5"
            :columns="tableColumnsFilter.length"
            :table-props="{ bordered: true, striped: true }"
          />
        </template>

        <!-- 查無資料 -->
        <template #empty>
          <div class="text-center my-5 animate__animated animate__fadeIn">
            <b-img
              :src="$store.state.app.notFoundImg"
              fluid
              width="480"
              alt="查無資料"
            />
          </div>
        </template>

        <!-- 欄位: 編號 -->
        <template #cell(id)="data">
          <div class="table-col">
            <span>{{ data.item.id }}</span>
          </div>
        </template>

        <!-- 欄位: 部門 -->
        <template #cell(department)="data">
          <div class="text-nowrap item-description">
            {{ data.item.department_id && data.item.department_info ? data.item.department_info.name : '' }}
          </div>
        </template>

        <!-- 欄位: 分類名稱 -->
        <template #cell(name)="data">
          <b-link
            class="font-weight-bold d-block text-nowrap item-description"
            @click="onSubmitUpdate(data.item)"
          >
            {{ data.item.name }}
          </b-link>
          <!-- <small class="text-muted">
            <div class="item-description">
              {{ data.item.department_id && data.item.department_info ? data.item.department_info.name : '' }}
            </div>
          </small> -->
        </template>

        <!-- 欄位: 分類說明 -->
        <template #cell(description)="data">
          <div
            class="table-col item-description"
            @click="onSubmitShowDescription(data.item)"
          >
            {{ data.item.description ? data.item.description : '---' }}
          </div>
        </template>

        <!-- 欄位: 今日 -->
        <template #cell(today_total)="data">
          <div class="table-col">
            {{ data.item.today_total ? parseInt(data.item.today_total, 10).toLocaleString() : '---' }}
          </div>
        </template>

        <!-- 欄位: 本週 -->
        <template #cell(week_total)="data">
          <div class="table-col">
            {{ data.item.week_total ? parseInt(data.item.week_total, 10).toLocaleString() : '---' }}
          </div>
        </template>

        <!-- 欄位: 本月 -->
        <template #cell(month_total)="data">
          <div class="table-col">
            {{ data.item.month_total ? parseInt(data.item.month_total, 10).toLocaleString() : '---' }}
          </div>
        </template>

        <!-- 欄位: 昨日 -->
        <template #cell(yesterday_total)="data">
          <div class="table-col">
            {{ data.item.yesterday_total ? parseInt(data.item.yesterday_total, 10).toLocaleString() : '---' }}
          </div>
        </template>

        <!-- 欄位: 上週 -->
        <template #cell(last_week_total)="data">
          <div class="table-col">
            {{ data.item.last_week_total ? parseInt(data.item.last_week_total, 10).toLocaleString() : '---' }}
          </div>
        </template>

        <!-- 欄位: 上月 -->
        <template #cell(last_month_total)="data">
          <div class="table-col">
            {{ data.item.last_month_total ? parseInt(data.item.last_month_total, 10).toLocaleString() : '---' }}
          </div>
        </template>

        <!-- 欄位: 完成總數 -->
        <template #cell(complete_total)="data">
          <div class="table-col">
            {{ data.item.complete_total ? parseInt(data.item.complete_total, 10).toLocaleString() : 0 }}
          </div>
        </template>

        <!-- 欄位: 待辦總數 -->
        <template #cell(total)="data">
          <div class="table-col">
            {{ data.item.total ? parseInt(data.item.total, 10).toLocaleString() : 0 }}
          </div>
        </template>

        <!-- 欄位: 完成率 -->
        <template #cell(complete)="data">
          <div class="d-flex align-items-center table-col">
            <span class="font-weight-bold text-body-heading mr-50 text-nowrap">{{ data.item.percentageAll }} %</span>
            <vue-apex-charts
              v-b-tooltip.hover.focus.v-secondary
              :title="`${data.item.complete_total} / ${data.item.total}`"
              type="radialBar"
              height="30"
              width="30"
              :options="data.item.chartDataAll.options"
              :series="data.item.chartDataAll.series"
            />
          </div>
        </template>

        <!-- 欄位: 上次更新 -->
        <template #cell(updated_at)="data">
          <div style="min-width: 85px;">
            <div v-if="data.item.updated_at">
              <span
                v-b-tooltip.hover.focus.v-secondary
                :title="`${moment(data.item.updated_at).format('HH:mm')}`"
              >
                {{ updateOnline(data.item.updated_at, refonlineTime) }}
              </span>
            </div>

            <div v-else>
              <span>---</span>
            </div>
          </div>
        </template>

        <!-- 欄位: 動作 -->
        <template #cell(actions)="data">
          <!-- ="data" -->
          <div class="d-flex mb-50">
            <div
              class="actions-link-btn mr-25"
              @click="onSubmitUpdate(data.item)"
            >
              <b-img
                v-b-tooltip.hover.focus.v-secondary
                title="編輯"
                src="/admin/images/table/edit.svg"
                class="actions-link-btn-image"
                rounded
              />
            </div>

            <div
              class="actions-link-btn mr-25"
              @click="onSubmitDelete(data.item)"
            >
              <b-img
                v-b-tooltip.hover.focus.v-secondary
                title="刪除"
                src="/admin/images/table/delete.svg"
                class="actions-link-btn-image"
                rounded
              />
            </div>
          </div>
        </template>
      </b-table>

      <!-- 顯示頁數/分頁 -->
      <div class="mx-2 mb-2">
        <b-row>
          <!-- 顯示頁數 -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">第 {{ dataMeta.from }} - {{ dataMeta.to }} 筆，共 {{ dataMeta.of }} 筆</span>
          </b-col>

          <!-- 分頁 -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalNum"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>

    </b-card>

    <b-modal
      v-if="selected"
      id="description-modal"
      centered
      hide-footer
    >
      <template #modal-title>
        <h4 class="m-0">
          分類說明
        </h4>
      </template>

      <div>
        <div class="device-name text-primary">
          {{ selected.name }}
        </div>

        <div class="device-description">{{ selected.description }}
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
// API
import { onUnmounted } from '@vue/composition-api'
import moment from 'moment'

// UI
import {
  BCard, BRow, BTable, BCol, BPagination, VBTooltip, BDropdown, BImg, BLink, // BBadge,
  BDropdownForm, BFormInput, BInputGroupPrepend, BInputGroup, BFormGroup, BFormCheckbox, BSkeletonTable,
  BInputGroupAppend, BModal,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import vSelect from 'vue-select'
import router from '@/router'
import store from '@/store'

// Component
import { useTodoClassList, useTodoSetting } from '../useTodo'
import UpdateModal from './ClassListUpdateModal.vue'
import { useSwalToast, useAlert } from '@/libs/mixins/index'
import useStoreModule from '../useStoreModule'

export default {
  metaInfo() {
    return {
      title: this.title ? this.title : store.state['app-config'].app.appName,
      titleTemplate: `%s - ${store.state.app.titleTemplate}`,
    }
  },
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
    BLink,
    BFormInput,
    BTable,
    // BBadge,
    BModal,
    BPagination,
    BDropdown,
    // BDropdownItem,
    BDropdownForm,
    BInputGroupPrepend,
    BInputGroupAppend,
    BInputGroup,
    BFormGroup,
    BFormCheckbox,
    BSkeletonTable,

    vSelect,
    VueApexCharts,
    UpdateModal,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [useSwalToast],
  data() {
    return {
      selected: null,
      title: router.currentRoute.meta.pageTitle,
    }
  },
  computed: {
    tableColumnsFilter() {
      // if (this.authAbility.user !== 'write') {
      //   return this.tableColumns
      //     .filter(f => f.select && f.key !== 'actions')
      // }
      return this.tableColumns
        .filter(f => f.select)
    },
    tableColumnsSearchable() {
      // if (this.authAbility.user !== 'write') {
      //   return this.tableColumns
      //     .filter(f => f.searchable && f.key !== 'actions')
      // }
      return this.tableColumns
        .filter(f => f.searchable)
    },
    authAbility() {
      return this.$store.state.app.ability
    },
  },
  mounted() {
    this.timer = setInterval(this.onlineTime, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    moment,
    // (觸發)顯示分類說明
    onSubmitShowDescription(item) {
      if (!item.description) return
      this.selected = item
      // this.useSwalAlertInfomation(item.name, item.description)
      setTimeout(() => { this.$bvModal.show('description-modal') }, 200)
    },

    // (觸發)新增/編輯CPU
    onSubmitUpdate(item) {
      if (!item) {
        this.selected = {}
        setTimeout(() => { this.$refs.updateModal.getData() }, 200)
        return
      }
      this.selected = item
      setTimeout(() => { this.$refs.updateModal.getData() }, 200)
    },

    // (刪除)分類
    onSubmitDelete(item) {
      // if (this.authAbility.user !== 'write') return
      this.useSwalAlertWarning('刪除作業分類', `你確定要永久刪除作業分類 ${item.name} 嗎?`)
        .then(result => {
          if (result.value) {
            this.setTodoClassDelete({
              type_id: item.id,
            }).then(() => {
              this.refetchData()
              this.useSwalAlertCenter(true, '刪除成功!', '分類已移除')
            })
              .catch(error => {
                this.useSwalAlertCenter(false, '刪除失敗!', error.response.data.message)
              })
          }
        })
    },
  },
  setup() {
    // 註冊模組
    const TODO_ADMIN_STORE_MODULE_NAME = 'admin-todo'

    if (!store.hasModule(TODO_ADMIN_STORE_MODULE_NAME)) store.registerModule(TODO_ADMIN_STORE_MODULE_NAME, useStoreModule)

    onUnmounted(() => {
      if (store.hasModule(TODO_ADMIN_STORE_MODULE_NAME)) store.unregisterModule(TODO_ADMIN_STORE_MODULE_NAME)
    })

    const {
      refDataListTable,
      perPage,
      totalNum,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      dataMeta,
      refetchData,
      refetchTable,
      timeRange,
      deviceTypeList,
      deviceTypeOptions,
      resolveDeviceType,

      setTodoClassDelete,
      getTodoClassListData,
    } = useTodoClassList()

    const {
      ui,
      statusOptions,
      refonlineTime,
      onlineTime,
      updateOnline,
    } = useTodoSetting()

    const {
      useAlertToast,
    } = useAlert()

    return {
      ui,
      useAlertToast,
      statusOptions,
      refDataListTable,
      perPage,
      totalNum,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      dataMeta,
      refetchData,
      refetchTable,
      timeRange,
      deviceTypeList,
      deviceTypeOptions,
      resolveDeviceType,

      setTodoClassDelete,
      getTodoClassListData,
      refonlineTime,
      onlineTime,
      updateOnline,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>
.item-description {
  // background-color: red;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 150px;
  // font-size: 1.4rem;
}

.device-name {
  font-size: 18px;
  margin-bottom: 8px;
}

.device-description {
  white-space: pre-wrap;
}

.btn-image-device-bind {
  img {
    height: 30px;
    width: 30px;
  }
  .btn-image-bind:hover {
    transition: transform 0.1s ease-in-out;
    transform: scale(1.2);
  }

  .btn-image-empty {
    opacity: 0.3;
  }
}
</style>
